export const colors = {
  page: '#000011',
  secondary: '#CAFB10',
  third: '#F31000',

  'league-amethyst-color': '#FFFFFF',
  'league-amethyst-border': '#6A0DAD',
  'league-amethyst-bg': '#6A0DAD',

  'league-tanzanite-color': '#FFFFFF',
  'league-tanzanite-border': '#4B3F72',
  'league-tanzanite-bg': '#4B3F72',

  'league-ruby-color': '#FFFFFF',
  'league-ruby-border': '#C1121F',
  'league-ruby-bg': '#C1121F',

  'league-alexandrite-color': '#FFFFFF',
  'league-alexandrite-border': '#2E8B57',
  'league-alexandrite-bg': '#2E8B57',

  'league-redBeryl-color': '#FFFFFF',
  'league-redBeryl-border': '#E34234',
  'league-redBeryl-bg': '#E34234',

  'league-jadeiteImperial-color': '#FFFFFF',
  'league-jadeiteImperial-border': '#00A86B',
  'league-jadeiteImperial-bg': '#00A86B',

  'league-diamondGlow-color': '#1A1A1A',
  'league-diamondGlow-border': '#B9F2FF',
  'league-diamondGlow-bg': '#B9F2FF',

  'league-diamond-color': '#FFD700',
  'league-diamond-border': '#8B0000',
  'league-diamond-bg': '#8B0000',
} as const;
